import qs from 'qs';
import { SLOTS } from 'types';
import { LANGUAGES } from 'i18n';
import { BaseService } from './BaseService';

export type ConfirmBetRequestDataType = { [key in SLOTS]: number };

export type ConfirmBetResponseDataType = {
  total: string;
};

export interface ICreatePendingBetRequestData {
  [SLOTS.player]: number;
  [SLOTS.tie]: number;
  [SLOTS.banker]: number;
  timeStamp: number;
}

export interface ICreatePendingBetResponseData {
  [SLOTS.player]: number;
  [SLOTS.tie]: number;
  [SLOTS.banker]: number;
  timeStamp: number;
  total: number;
}

export interface IStreamLoadRequestData {
  sessionId: string;
  time: number;
  load: boolean;
}

class RestAPIService extends BaseService {
  public async confirmBet(data: ConfirmBetRequestDataType) {
    const result = await this.post<ConfirmBetResponseDataType | null>(
      'bets/create/',
      qs.stringify(data),
      {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    );

    if (result.status === 201) {
      return result.data;
    }

    return null;
  }

  public async createPendingBet(data: ICreatePendingBetRequestData) {
    const result = await this.post<ICreatePendingBetResponseData | null>(
      'bets/pending-bets/create',
      data,
      {
        'Content-Type': 'application/json; charset=utf-8',
      },
    );

    if (result.status === 201) {
      return result.data;
    }

    return null;
  }

  public async sendStreamLoadData(data: IStreamLoadRequestData) {
    return await this.post('loading', data, {
      'Content-Type': 'application/json; charset=utf-8',
    });
  }

  public async getGameRules(locale: LANGUAGES) {
    const route = `game-rules/${locale}`;

    return this.getAPI(route);
  }

  public async getHistory() {
    const route = `bets/history`;

    return this.getAPI(route);
  }
}

export const RestService = new RestAPIService();
